export default __webpack_public_path__ + "static/media/yachts_default.837dcad3.svg";